export enum BuySellHiveTransactionType {
  None = 0,
  Sell = 2,
  Buy = 1,
  Cancel = 3
}
